// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"18286963","511":"7b0a5e99","684":"6c3caf9c","989":"bec3d3ea"}[chunkId] + ".chunk.js";
};